import clsx from 'clsx';
import React from 'react';

interface SeparatorProps {
  className?: string;
}

const Separator = ({ className }: SeparatorProps) => {
  return <span className={clsx(className, 'h-4 w-4 rounded-full bg-grayscale-beige')}></span>;
};

export default Separator;
